module.exports = __webpack_public_path__ + "img/partner4.07a03ef3.jpg";